/* ==================================================
   MATCH DETAILS 2026 — WOMEN
   ================================================== */

import type { MatchDetails } from "./types";

export const matchDetailsWomen: MatchDetails[] = [
  // ==================================================
  // WOMEN'S INTERNATIONAL TESTS
  // ==================================================

  {
    matchKey: "south-africa-w-vs-usa-w",
    performances: [
      { category: "Captain", player: "Sizophila Solontsi", value: "South Africa W" },
      { category: "Captain", player: "Georgie Perris-Redding", value: "USA W" },
      { category: "Venue", player: "Loftus Versfeld", value: "Pretoria" },
    ],
  },

  {
    matchKey: "japan-w-vs-fiji-w",
    performances: [
      { category: "Coach", player: "TBD", value: "Japan W" },
      { category: "Coach", player: "TBD", value: "Fiji W" },
      { category: "Captain", player: "TBD", value: "Japan W" },
      { category: "Captain", player: "TBD", value: "Fiji W" },
      { category: "Venue", player: "Japan Base", value: "Fukuoka" },
    ],
  },

  {
  matchKey: "south-africa-w-vs-new-zealand-w",
  performances: [
    { category: "Coach", player: "TBC", value: "South Africa W" },
    { category: "Coach", player: "Allan Bunting", value: "New Zealand W" },
    { category: "Captain", player: "Babalwa Latsha", value: "South Africa W" },
    { category: "Captain", player: "Georgia Ponsonby", value: "New Zealand W" },
    { category: "Venue", player: "FNB Stadium", value: "Johannesburg" },
    { category: "Referee", player: "Zoe Naude", value: "SARU" },
    { category: "Assistant Referee 1", player: "Giana Viljoen", value: "SARU" },
    { category: "Assistant Referee 2", player: "Angie Bezuidenhout", value: "SARU" },
    { category: "TMO", player: "Quinton Immelman", value: "SARU" },
    { category: "FPRO", player: "Christie du Preez", value: "SARU" },
  ],
},

  {
    matchKey: "south-africa-w-vs-ireland-w",
    performances: [
      { category: "Coach", player: "TBD", value: "South Africa W" },
      { category: "Coach", player: "TBD", value: "Ireland W" },
      { category: "Captain", player: "TBD", value: "South Africa W" },
      { category: "Captain", player: "TBD", value: "Ireland W" },
      { category: "Venue", player: "Athlone Stadium", value: "Cape Town" },
    ],
  },

  // ==================================================
  // WOMEN'S SIX NATIONS 2026
  // ==================================================

  {
    matchKey: "france-w-vs-italy-w",
    performances: [
      { category: "Most Meters", player: "M. Ménager (France)", value: "142m" },
      { category: "Most Tackles", player: "C. Gros (France)", value: "18 tackles" },
      { category: "Most Try Assists", player: "B. Vernier (France)", value: "3 assists" },
    ],
  },

  {
    matchKey: "england-w-vs-ireland-w",
    performances: [
      { category: "Most Meters", player: "A. Breach (England)", value: "168m" },
      { category: "Most Tackles", player: "Z. Harrison (England)", value: "21 tackles" },
      { category: "Most Try Assists", player: "H. Aitchison (England)", value: "4 assists" },
    ],
  },

  {
    matchKey: "wales-w-vs-scotland-w",
    performances: [
      { category: "Most Meters", player: "C. Rollie (Scotland)", value: "135m" },
      { category: "Most Tackles", player: "R. McCormick (Scotland)", value: "19 tackles" },
    ],
  },

  {
    matchKey: "scotland-w-vs-england-w",
    performances: [
      { category: "Most Meters", player: "A. Breach (England)", value: "178m" },
      { category: "Most Tackles", player: "Z. Harrison (England)", value: "24 tackles" },
    ],
  },

  {
    matchKey: "wales-w-vs-france-w",
    performances: [
      { category: "Most Meters", player: "M. Ménager (France)", value: "155m" },
      { category: "Most Tackles", player: "C. Gros (France)", value: "22 tackles" },
    ],
  },

  {
    matchKey: "ireland-w-vs-italy-w",
    performances: [
      { category: "Most Meters", player: "A. Doyle (Ireland)", value: "152m" },
      { category: "Most Tackles", player: "B. McCormack (Ireland)", value: "20 tackles" },
    ],
  },

  {
    matchKey: "england-w-vs-wales-w",
    performances: [
      { category: "Most Meters", player: "A. Breach", value: "165m" },
      { category: "Most Tackles", player: "Z. Harrison", value: "20 tackles" },
    ],
  },

  {
    matchKey: "italy-w-vs-scotland-w",
    performances: [
      { category: "Most Meters", player: "C. Rollie", value: "140m" },
    ],
  },

  {
    matchKey: "france-w-vs-ireland-w",
    performances: [
      { category: "Most Tackles", player: "C. Gros", value: "21 tackles" },
    ],
  },

  {
    matchKey: "italy-w-vs-england-w",
    performances: [
      { category: "Most Meters", player: "E. Kildunne", value: "172m" },
    ],
  },

  {
    matchKey: "scotland-w-vs-france-w",
    performances: [
      { category: "Most Meters", player: "B. Vernier", value: "160m" },
    ],
  },

  {
    matchKey: "ireland-w-vs-wales-w",
    performances: [
      { category: "Most Tackles", player: "B. McCormack", value: "22 tackles" },
    ],
  },

// ==================================================
  // WXV GLOBAL SERIES 2026 (WXV 1)
  // ==================================================

  {
  matchKey: "england-w-vs-australia-w",
  highlightsUrl: "https://www.youtube.com/watch?v=IAI4BElu6WQ",
matchStats: {
  home: { // England
    metresMade: 540,
    carries: 145,
    defendersBeaten: 35,
    cleanBreaks: 12,
    offloads: 10,
    tacklesMade: 125,
    tacklesMissed: 22,
    turnoversWon: 9,
    penaltiesConceded: 8,
  },
  away: { // Australia
    metresMade: 280,
    carries: 95,
    defendersBeaten: 15,
    cleanBreaks: 4,
    offloads: 5,
    tacklesMade: 165,
    tacklesMissed: 38,
    turnoversWon: 6,
    penaltiesConceded: 11,
  },
},
  timeline: [
    { minute: "0'", label: "Kick-off — CorpAcq Stadium, Manchester" },
    { minute: "40'", label: "Half Time" },
    { minute: "80'", label: "Full Time" },
  ],
  lineups: {
    homeStarting: [
      { number: 1, name: "Mackenzie Carson" },
      { number: 2, name: "May Campbell" },
      { number: 3, name: "Sarah Bern" },
      { number: 4, name: "Delaney Burns" },
      { number: 5, name: "Lilli Ives Campion" },
      { number: 6, name: "Aoife Burton" },
      { number: 7, name: "Sadia Kabeya" },
      { number: 8, name: "Maddie Feaunati" },
      { number: 9, name: "Natasha Hunt" },
      { number: 10, name: "Holly Aitchison" },
      { number: 11, name: "Mia Venner" },
      { number: 12, name: "Tatyana Heard" },
      { number: 13, name: "Meg Jones (C)" },
      { number: 14, name: "Claudia Moloney-MacDonald" },
      { number: 15, name: "Ellie Kildunne" },
    ],
    homeBench: [
      { number: 16, name: "Bryony Field" },
      { number: 17, name: "Hannah Botterman" },
      { number: 18, name: "Maud Muir" },
      { number: 19, name: "Morwenna Talling" },
      { number: 20, name: "Marlie Packer" },
      { number: 21, name: "Lucy Packer" },
      { number: 22, name: "Zoe Harrison" },
      { number: 23, name: "Helena Rowland" },
    ],
    awayStarting: [
      { number: 1, name: "Bree-Anna Hoy" },
      { number: 2, name: "Ashley Marsters" },
      { number: 3, name: "Eva Karpani" },
      { number: 4, name: "Kaitlan Leaney" },
      { number: 5, name: "Atasi Lafai" },
      { number: 6, name: "Leilani Tapsell" },
      { number: 7, name: "Siokapesi Palu" },
      { number: 8, name: "Grace Kemp" },
      { number: 9, name: "Layla Sae" },
      { number: 10, name: "Carys Dallinger" },
      { number: 11, name: "Amelia Whitaker" },
      { number: 12, name: "Cecilia Smith" },
      { number: 13, name: "Georgina Friedrichs" },
      { number: 14, name: "Desiree Miller" },
      { number: 15, name: "Caitlyn Halse" },
    ],
    awayBench: [
      { number: 16, name: "Tania Naden" },
      { number: 17, name: "Sera Naiqama" },
      { number: 18, name: "Lydia Kavoa" },
      { number: 19, name: "Michaela Leonard" },
      { number: 20, name: "Jemma Bemrose" },
      { number: 21, name: "Samantha Wood" },
      { number: 22, name: "Trilleen Pomare" },
      { number: 23, name: "Ivania Wong" },
    ],
  },
  performances: [
    { category: "Coach", player: "John Mitchell", value: "England W" },
    { category: "Coach", player: "Joanne Yapp", value: "Australia W" },
    { category: "Captain", player: "Meg Jones", value: "England W" },
    { category: "Captain", player: "Michaela Leonard", value: "Australia W" },
    { category: "Venue", player: "CorpAcq Stadium", value: "Manchester" },
  ],
},

{
  matchKey: "scotland-w-vs-canada-w",
  highlightsUrl: "https://www.bbc.com/sport/rugby-union/articles/c20lepd22edo",
matchStats: {
  home: { // Scotland
    metresMade: 320,
    carries: 105,
    defendersBeaten: 18,
    cleanBreaks: 5,
    offloads: 7,
    tacklesMade: 155,
    tacklesMissed: 40,
    turnoversWon: 5,
    penaltiesConceded: 12,
  },
  away: { // Canada
    metresMade: 580,
    carries: 150,
    defendersBeaten: 42,
    cleanBreaks: 15,
    offloads: 12,
    tacklesMade: 110,
    tacklesMissed: 20,
    turnoversWon: 10,
    penaltiesConceded: 9,
  },
},
  timeline: [
    { minute: "0'", label: "Kick-off — Hive Stadium, Edinburgh" },
    { minute: "40'", label: "Half Time" },
    { minute: "80'", label: "Full Time" },
  ],
  lineups: {
    homeStarting: [
      { number: 1, name: "Leah Bartlett" },
      { number: 2, name: "Lana Skeldon" },
      { number: 3, name: "Elliann Clarke" },
      { number: 4, name: "Emma Wassell" },
      { number: 5, name: "Hollie Cunningham" },
      { number: 6, name: "Rachel Malcolm (C)" },
      { number: 7, name: "Evie Gallagher" },
      { number: 8, name: "Becky Boyd" },
      { number: 9, name: "Rhea Clarke" },
      { number: 10, name: "Helen Nelson" },
      { number: 11, name: "Rhona Lloyd" },
      { number: 12, name: "Meryl Smith" },
      { number: 13, name: "Rachel Philipps" },
      { number: 14, name: "Shona Campbell" },
      { number: 15, name: "Chloe Rollie" },
    ],
    homeBench: [
      { number: 16, name: "Aicha Sutcliffe" },
      { number: 17, name: "Anne Young" },
      { number: 18, name: "Molly Poolman" },
      { number: 19, name: "Eva Donaldson" },
      { number: 20, name: "Adelle Ferrie" },
      { number: 21, name: "Ceitidh Ainsworth" },
      { number: 22, name: "Hannah Ramsay" },
      { number: 23, name: "Katie Buchanan" },
    ],
    awayStarting: [
      { number: 1, name: "Brittany Kassil" },
      { number: 2, name: "Kiki Idowu" },
      { number: 3, name: "DaLeaka Menin" },
      { number: 4, name: "Rachel Smith" },
      { number: 5, name: "Laetitia Royer" },
      { number: 6, name: "Julia Omokhuale" },
      { number: 7, name: "Lizzie Gibson" },
      { number: 8, name: "Gabrielle Senft" },
      { number: 9, name: "Olivia Apps" },
      { number: 10, name: "Taylor Perry" },
      { number: 11, name: "Charity Williams" },
      { number: 12, name: "Alexandra Tessier (C)" },
      { number: 13, name: "Florence Symonds" },
      { number: 14, name: "Fancy Bermudez" },
      { number: 15, name: "Claire Gallagher" },
    ],
    awayBench: [
      { number: 16, name: "Emily Tuttosi" },
      { number: 17, name: "Sophie McDonald" },
      { number: 18, name: "Brooke Rempel" },
      { number: 19, name: "Sophie de Goede" },
      { number: 20, name: "Pamphinette Buisa" },
      { number: 21, name: "Justine Pelletier" },
      { number: 22, name: "Savannah Bauder" },
      { number: 23, name: "Asia Hogan-Rochester" },
    ],
  },
  performances: [
    { category: "Coach", player: "Dave Campbell (interim)", value: "Scotland W" },
    { category: "Coach", player: "Kévin Rouet", value: "Canada W" },
    { category: "Captain", player: "Rachel Malcolm", value: "Scotland W" },
    { category: "Captain", player: "Alexandra Tessier", value: "Canada W" },
    { category: "Venue", player: "Hive Stadium", value: "Edinburgh" },
  ],
},
{
  matchKey: "france-w-vs-new-zealand-w",
  highlightsUrl: "https://www.youtube.com/watch?v=zcAqP1XgWD0",
  matchStats: {
    home: { // France
      metresMade: 290,
      carries: 100,
      defendersBeaten: 16,
      cleanBreaks: 4,
      offloads: 6,
      tacklesMade: 145,
      tacklesMissed: 28,
      turnoversWon: 7,
      penaltiesConceded: 10,
    },
    away: { // New Zealand
      metresMade: 420,
      carries: 125,
      defendersBeaten: 26,
      cleanBreaks: 8,
      offloads: 9,
      tacklesMade: 130,
      tacklesMissed: 18,
      turnoversWon: 8,
      penaltiesConceded: 8,
    },
  },
  timeline: [
    { minute: "0'", label: "Kick-off — Matmut Stadium de Gerland, Lyon" },
    { minute: "14'", label: "Try Justine McGregor (NZ) — 0-7" },
    { minute: "26'", label: "Try Mia Anderson (NZ) — 0-14" },
    { minute: "36'", label: "Try Pauline Bourdon-Sansus (FRA) — 7-14" },
    { minute: "40'", label: "Half Time — 7-14" },
    { minute: "46'", label: "Try Mererangi Paul (NZ) — 7-21" },
    { minute: "67'", label: "Try Lina Queyroi (FRA) — 14-21" },
    { minute: "71'", label: "Try Liana Mikaele-Tu'u (NZ) — 14-28" },
    { minute: "80'", label: "Full Time — France 14–28 New Zealand" },
  ],
  lineups: {
    homeStarting: [
      { number: 1, name: "Ambre Mwayembe" },
      { number: 2, name: "Mathilde Lazarko" },
      { number: 3, name: "Assia Khalfaoui" },
      { number: 4, name: "Julia Grosz" },
      { number: 5, name: "Siobhan Soqeta" },
      { number: 6, name: "Axelle Berthoumieu" },
      { number: 7, name: "Léa Champon" },
      { number: 8, name: "Charlotte Escudero" },
      { number: 9, name: "Pauline Bourdon-Sansus (C)" },
      { number: 10, name: "Carla Arbez" },
      { number: 11, name: "Léa Murie" },
      { number: 12, name: "Teani Feleu" },
      { number: 13, name: "Lili Dezou" },
      { number: 14, name: "Kelly Arbey" },
      { number: 15, name: "Chloé Jacquet" },
    ],
    homeBench: [
      { number: 16, name: "Élisa Riffonneau" },
      { number: 17, name: "Yllana Brosseau" },
      { number: 18, name: "Annaëlle Deshaye" },
      { number: 19, name: "Cloé Correa" },
      { number: 20, name: "Khoudedia Cissokho" },
      { number: 21, name: "Alexandra Chambon" },
      { number: 22, name: "Lina Queyroi" },
      { number: 23, name: "Gabrielle Vernier" },
    ],
    awayStarting: [
      { number: 1, name: "Chryss Viliko" },
      { number: 2, name: "Georgia Ponsonby (C)" },
      { number: 3, name: "Veisinia Mahutariki-Fakalelu" },
      { number: 4, name: "Maiakawanakaulani Roos" },
      { number: 5, name: "Laura Bayfield" },
      { number: 6, name: "Mia Anderson" },
      { number: 7, name: "Elinor-Plum King" },
      { number: 8, name: "Liana Mikaele-Tu'u" },
      { number: 9, name: "Maia Joseph" },
      { number: 10, name: "Hannah King" },
      { number: 11, name: "Justine McGregor" },
      { number: 12, name: "Sylvia Brunt" },
      { number: 13, name: "Amy Du Plessis" },
      { number: 14, name: "Mererangi Paul" },
      { number: 15, name: "Braxton Sorensen-McGee" },
    ],
    awayBench: [
      { number: 16, name: "Atlanta Lolohea" },
      { number: 17, name: "Maddison Robinson" },
      { number: 18, name: "Santo Taumata" },
      { number: 19, name: "Maama Mo'onia Vaipulu" },
      { number: 20, name: "Layla Sae" },
      { number: 21, name: "Tara Turner" },
      { number: 22, name: "Shyrah Tuliau-Tua'a" },
      { number: 23, name: "Alena Saili" },
    ],
  },
  performances: [
    { category: "Coach", player: "François Ratier", value: "France W" },
    { category: "Coach", player: "Whitney Hansen", value: "New Zealand W" },
    { category: "Captain", player: "Pauline Bourdon-Sansus", value: "France W" },
    { category: "Captain", player: "Georgia Ponsonby", value: "New Zealand W" },
    { category: "Venue", player: "Matmut Stadium de Gerland", value: "Lyon" },
  ],
},

// ==================================================
// WXV GLOBAL SERIES 2026 (WXV 1) — ROUND 2
// ==================================================

// ----- FRIDAY 18 SEPTEMBER 2026 -----

{
  matchKey: "wales-w-vs-south-africa-w",
  highlightsUrl: "https://www.youtube.com/watch?v=8pUl5kOHgyE",
  timeline: [
    { minute: "0'", label: "Kick-off — Cardiff Arms Park, Cardiff" },
    { minute: "40'", label: "Half Time" },
    { minute: "80'", label: "Full Time" },
  ],
  lineups: {
    homeStarting: [
      { number: 1, name: "Maisie Davies" },
      { number: 2, name: "Kelsey Jones" },
      { number: 3, name: "Sisilia Tuipulotu" },
      { number: 4, name: "Branwen Metcalfe" },
      { number: 5, name: "Georgia Evans" },
      { number: 6, name: "Kate Williams (C)" },
      { number: 7, name: "Alex Callender (C)" },
      { number: 8, name: "Bryonie King" },
      { number: 9, name: "Seren Lockwood" },
      { number: 10, name: "Keira Bevan" },
      { number: 11, name: "Amy Williams" },
      { number: 12, name: "Freya Bell" },
      { number: 13, name: "Courtney Keight" },
      { number: 14, name: "Seren Singleton" },
      { number: 15, name: "Lisa Neumann" },
    ],
    homeBench: [
      { number: 16, name: "Shanelle Williams" },
      { number: 17, name: "Gwenllian Pyrs" },
      { number: 18, name: "Elan Jones" },
      { number: 19, name: "Gwen Crabb" },
      { number: 20, name: "Jorja Aiono" },
      { number: 21, name: "Alisha Joyce" },
      { number: 22, name: "Lleucu George" },
      { number: 23, name: "Jenna De Vera" },
    ],
    awayStarting: [
      { number: 1, name: "Sanelisiwe Charlie" },
      { number: 2, name: "Lindelwa Gwala" },
      { number: 3, name: "Babalwa Latsha (C)" },
      { number: 4, name: "Vainah Ubisi" },
      { number: 5, name: "Danelle Lochner" },
      { number: 6, name: "Sizophila Solontsi" },
      { number: 7, name: "Catha Jacobs" },
      { number: 8, name: "Logan Welman" },
      { number: 9, name: "Felicia Jacobs" },
      { number: 10, name: "Libbie Janse van Rensburg" },
      { number: 11, name: "Ayanda Malinga" },
      { number: 12, name: "Aphiwe Ngwevu" },
      { number: 13, name: "Maceala Samboya" },
      { number: 14, name: "Maria Tshiremba" },
      { number: 15, name: "Byrhandré Dolf" },
    ],
    awayBench: [
      { number: 16, name: "Micke Gunter" },
      { number: 17, name: "Xoliswa Khuzwayo" },
      { number: 18, name: "Nombuyekezo Mdliki" },
      { number: 19, name: "Nomsa Mokwai" },
      { number: 20, name: "Aseza Hele" },
      { number: 21, name: "Sinelitha Noxeke" },
      { number: 22, name: "Jakkie Cilliers" },
      { number: 23, name: "Patience Mokone" },
    ],
  },
  performances: [
    { category: "Coach", player: "Sean Lynn", value: "Wales W" },
    { category: "Coach", player: "Laurian Johannes-Haupt & Franzel September", value: "South Africa W" },
    { category: "Captain", player: "Alex Callender & Kate Williams", value: "Wales W" },
    { category: "Captain", player: "Babalwa Latsha", value: "South Africa W" },
    { category: "Venue", player: "Cardiff Arms Park", value: "Cardiff" },
  ],
},

// ----- SATURDAY 19 SEPTEMBER 2026 -----

{
  matchKey: "england-w-vs-canada-w",
  highlightsUrl: "https://www.youtube.com/watch?v=hRdgyCIaM-g",
  timeline: [
    { minute: "0'", label: "Kick-off — Sandy Park, Exeter" },
    { minute: "40'", label: "Half Time" },
    { minute: "80'", label: "Full Time" },
  ],
  lineups: {
    homeStarting: [
      { number: 1, name: "Hannah Botterman" },
      { number: 2, name: "Bryony Field" },
      { number: 3, name: "Maud Muir" },
      { number: 4, name: "Morwenna Talling" },
      { number: 5, name: "Lilli Ives Campion" },
      { number: 6, name: "Abi Burton" },
      { number: 7, name: "Sadia Kabeya" },
      { number: 8, name: "Alex Matthews" },
      { number: 9, name: "Lucy Packer" },
      { number: 10, name: "Zoe Harrison" },
      { number: 11, name: "Claudia Moloney-MacDonald" },
      { number: 12, name: "Helena Rowland" },
      { number: 13, name: "Megan Jones (C)" },
      { number: 14, name: "Jess Breach" },
      { number: 15, name: "Ellie Kildunne" },
    ],
    homeBench: [
      { number: 16, name: "May Campbell" },
      { number: 17, name: "Mackenzie Carson" },
      { number: 18, name: "Sarah Bern" },
      { number: 19, name: "Delaney Burns" },
      { number: 20, name: "Maddie Feaunati" },
      { number: 21, name: "Marlie Packer" },
      { number: 22, name: "Flo Robinson" },
      { number: 23, name: "Holly Aitchison" },
    ],
    awayStarting: [
      { number: 1, name: "Mikiela Nelson" },
      { number: 2, name: "Kiki Idowu" },
      { number: 3, name: "DaLeaka Menin" },
      { number: 4, name: "Sophie de Goede" },
      { number: 5, name: "Laetitia Royer" },
      { number: 6, name: "Rachel Smith" },
      { number: 7, name: "Julia Omokhuale" },
      { number: 8, name: "Lizzie Gibson" },
      { number: 9, name: "Olivia Apps" },
      { number: 10, name: "Taylor Perry" },
      { number: 11, name: "Charity Williams" },
      { number: 12, name: "Alexandra Tessier (C)" },
      { number: 13, name: "Florence Symonds" },
      { number: 14, name: "Asia Hogan-Rochester" },
      { number: 15, name: "Claire Gallagher" },
    ],
    awayBench: [
      { number: 16, name: "TBD" },
      { number: 17, name: "TBD" },
      { number: 18, name: "TBD" },
      { number: 19, name: "TBD" },
      { number: 20, name: "TBD" },
      { number: 21, name: "TBD" },
      { number: 22, name: "TBD" },
      { number: 23, name: "TBD" },
    ],
  },
  performances: [
    { category: "Coach", player: "John Mitchell", value: "England W" },
    { category: "Coach", player: "Kévin Rouet", value: "Canada W" },
    { category: "Captain", player: "Megan Jones", value: "England W" },
    { category: "Captain", player: "Alexandra Tessier", value: "Canada W" },
    { category: "Venue", player: "Sandy Park", value: "Exeter" },
  ],
},
{
  matchKey: "france-w-vs-australia-w",
  highlightsUrl: "https://www.youtube.com/watch?v=tjQAyN4s3zU",
  timeline: [
    { minute: "0'", label: "Kick-off — Matmut Stadium de Gerland, Lyon" },
    { minute: "40'", label: "Half Time" },
    { minute: "80'", label: "Full Time" },
  ],
  lineups: {
    homeStarting: [
      { number: 1, name: "Ambre Mwayembe" },
      { number: 2, name: "Elisa Riffonneau" },
      { number: 3, name: "Assia Khalfaoui" },
      { number: 4, name: "Julia Grosz" },
      { number: 5, name: "Cloé Corréa" },
      { number: 6, name: "Axelle Berthoumieu" },
      { number: 7, name: "Léa Champon" },
      { number: 8, name: "Charlotte Escudero" },
      { number: 9, name: "Pauline Bourdon Sansus (C)" },
      { number: 10, name: "Carla Arbez" },
      { number: 11, name: "Léa Murie" },
      { number: 12, name: "Téani Feleu" },
      { number: 13, name: "Gabrielle Vernier" },
      { number: 14, name: "Anaïs Grando" },
      { number: 15, name: "Emilie Boulard" },
    ],
    homeBench: [
      { number: 16, name: "Maïlys Mailagi" },
      { number: 17, name: "Yllana Brosseau" },
      { number: 18, name: "Annaëlle Deshaye" },
      { number: 19, name: "Siobhan Soqeta" },
      { number: 20, name: "Mouna Toure" },
      { number: 21, name: "Alexandra Chambon" },
      { number: 22, name: "Lina Queyroi" },
      { number: 23, name: "Elodie Fernandez" },
    ],
    awayStarting: [
      { number: 1, name: "Allana Sikimeti" },
      { number: 2, name: "Brittany Merlo" },
      { number: 3, name: "Faliki Pohiva" },
      { number: 4, name: "Kaitlan Leaney" },
      { number: 5, name: "Michaela Leonard" },
      { number: 6, name: "Pia Tapsell" },
      { number: 7, name: "Piper Duck" },
      { number: 8, name: "Siokapesi Palu Sekona (C)" },
      { number: 9, name: "Samantha Wood" },
      { number: 10, name: "Waiaria Ellis" },
      { number: 11, name: "Desiree Miller" },
      { number: 12, name: "Faitala Moleka" },
      { number: 13, name: "Georgina Friedrichs" },
      { number: 14, name: "Amelia Whitaker" },
      { number: 15, name: "Caitlyn Halse" },
    ],
    awayBench: [
      { number: 16, name: "Tania Naden" },
      { number: 17, name: "Brianna Hoy" },
      { number: 18, name: "Eva Karpani" },
      { number: 19, name: "Tiarah Minns" },
      { number: 20, name: "Tabua Tuinakauvadra" },
      { number: 21, name: "Tia Hinds" },
      { number: 22, name: "Piper Flynn" },
      { number: 23, name: "TBD" },
    ],
  },
  performances: [
    { category: "Coach", player: "François Ratier", value: "France W" },
    { category: "Coach", player: "Joanne Yapp", value: "Australia W" },
    { category: "Captain", player: "Pauline Bourdon Sansus", value: "France W" },
    { category: "Captain", player: "Siokapesi Palu Sekona", value: "Australia W" },
    { category: "Venue", player: "Matmut Stadium de Gerland", value: "Lyon" },
  ],
},
{
  matchKey: "scotland-w-vs-new-zealand-w",
  highlightsUrl: "https://www.youtube.com/watch?v=64bG00f00lU",
  timeline: [
    { minute: "0'", label: "Kick-off — Hive Stadium, Edinburgh" },
    { minute: "40'", label: "Half Time" },
    { minute: "80'", label: "Full Time" },
  ],
  lineups: {
    homeStarting: [
      { number: 1, name: "Anne Young" },
      { number: 2, name: "Lana Skeldon" },
      { number: 3, name: "Elliann Clarke" },
      { number: 4, name: "Emma Wassell" },
      { number: 5, name: "Holland Bogan" },
      { number: 6, name: "Rachel Malcolm (C)" },
      { number: 7, name: "Eva Donaldson" },
      { number: 8, name: "Evie Gallagher" },
      { number: 9, name: "Ceitidh Ainsworth" },
      { number: 10, name: "Helen Nelson" },
      { number: 11, name: "Shona Campbell" },
      { number: 12, name: "Meryl Smith" },
      { number: 13, name: "Rachel Philipps" },
      { number: 14, name: "Rhona Lloyd" },
      { number: 15, name: "Chloe Rollie" },
    ],
    homeBench: [
      { number: 16, name: "Aicha Sutcliffe" },
      { number: 17, name: "Leah Bartlett" },
      { number: 18, name: "Molly Poolman" },
      { number: 19, name: "Sarah Bonar" },
      { number: 20, name: "Adelle Ferrie" },
      { number: 21, name: "Rhea Clarke" },
      { number: 22, name: "Hannah Ramsay" },
      { number: 23, name: "Katie Buchanan" },
    ],
    awayStarting: [
      { number: 1, name: "Maddison Robinson" },
      { number: 2, name: "Georgia Ponsonby (C)" },
      { number: 3, name: "Mo'omo'oga Palu" },
      { number: 4, name: "Maama Mo'onia Vaipulu" },
      { number: 5, name: "Laura Bayfield" },
      { number: 6, name: "Layla Sae" },
      { number: 7, name: "Elinor-Plum King" },
      { number: 8, name: "Mia Anderson" },
      { number: 9, name: "Tara Turner" },
      { number: 10, name: "Hannah King" },
      { number: 11, name: "Shyrah Tuliau-Tua'a" },
      { number: 12, name: "Alena Saili" },
      { number: 13, name: "Amy Du Plessis" },
      { number: 14, name: "Justine McGregor" },
      { number: 15, name: "Braxton Sorensen-McGee" },
    ],
    awayBench: [
      { number: 16, name: "Vici-Rose Green" },
      { number: 17, name: "Ngano Tavake" },
      { number: 18, name: "Veisinia Mahutariki-Fakalelu" },
      { number: 19, name: "Maiakawanakaulani Roos" },
      { number: 20, name: "Amarante Sititi" },
      { number: 21, name: "Maia Joseph" },
      { number: 22, name: "Logo-I-Pulotu Lemapu-Atai'i Sylvia Brunt" },
      { number: 23, name: "Maia Davis" },
    ],
  },
  performances: [
    { category: "Coach", player: "Dave Butcher (interim)", value: "Scotland W" },
    { category: "Coach", player: "Whitney Hansen", value: "New Zealand W" },
    { category: "Captain", player: "Rachel Malcolm", value: "Scotland W" },
    { category: "Captain", player: "Georgia Ponsonby", value: "New Zealand W" },
    { category: "Venue", player: "Hive Stadium", value: "Edinburgh" },
  ],
},
{
  matchKey: "italy-w-vs-japan-w",
  highlightsUrl: "https://www.youtube.com/watch?v=c7ikWeMsYnA",
  timeline: [
    { minute: "0'", label: "Kick-off — Stadio Omero Tognon, Fontanafredda" },
    { minute: "40'", label: "Half Time" },
    { minute: "80'", label: "Full Time" },
  ],
  lineups: {
    homeStarting: [
      { number: 1, name: "Silvia Turani" },
      { number: 2, name: "Vittoria Vecchini" },
      { number: 3, name: "Vittoria Zanette" },
      { number: 4, name: "Alessandra Frangipani" },
      { number: 5, name: "Giordana Duca" },
      { number: 6, name: "Margherita Tonellotto" },
      { number: 7, name: "Alissa Ranuccini" },
      { number: 8, name: "Francesca Sgorbini" },
      { number: 9, name: "Sofia Stefan" },
      { number: 10, name: "Emma Stevanin" },
      { number: 11, name: "Francesca Granzotto" },
      { number: 12, name: "Sara Mannini" },
      { number: 13, name: "Alyssa D'Incà" },
      { number: 14, name: "Aura Muzzo" },
      { number: 15, name: "Vittoria Ostuni Minuzzi (C)" },
    ],
    homeBench: [
      { number: 16, name: "Chiara Cheli" },
      { number: 17, name: "Laura Foscato" },
      { number: 18, name: "Alessia Pilani" },
      { number: 19, name: "Giulia Cavina" },
      { number: 20, name: "Beatrice Veronese" },
      { number: 21, name: "Alia Bitonci" },
      { number: 22, name: "Beatrice Rigoni" },
      { number: 23, name: "Natascia Aggio" },
    ],
    awayStarting: [
      { number: 1, name: "TBD" },
      { number: 2, name: "TBD" },
      { number: 3, name: "TBD" },
      { number: 4, name: "TBD" },
      { number: 5, name: "TBD" },
      { number: 6, name: "TBD" },
      { number: 7, name: "TBD" },
      { number: 8, name: "TBD" },
      { number: 9, name: "TBD" },
      { number: 10, name: "TBD" },
      { number: 11, name: "TBD" },
      { number: 12, name: "TBD" },
      { number: 13, name: "TBD" },
      { number: 14, name: "TBD" },
      { number: 15, name: "TBD" },
    ],
    awayBench: [
      { number: 16, name: "TBD" },
      { number: 17, name: "TBD" },
      { number: 18, name: "TBD" },
      { number: 19, name: "TBD" },
      { number: 20, name: "TBD" },
      { number: 21, name: "TBD" },
      { number: 22, name: "TBD" },
      { number: 23, name: "TBD" },
    ],
  },
  performances: [
    { category: "Coach", player: "Plinio Sciamanna", value: "Italy W" },
    { category: "Coach", player: "TBD", value: "Japan W" },
    { category: "Captain", player: "Vittoria Ostuni Minuzzi", value: "Italy W" },
    { category: "Captain", player: "TBD", value: "Japan W" },
    { category: "Venue", player: "Stadio Omero Tognon", value: "Fontanafredda" },
  ],
},

// ==================================================
// WXV GLOBAL SERIES 2026 (WXV 1) — ROUND 3
// ==================================================

{
  matchKey: "italy-w-vs-south-africa-w",
  timeline: [
    { minute: "0'", label: "Kick-off — Stadio Omero Tognon, Fontanafredda" },
    { minute: "40'", label: "Half Time" },
    { minute: "80'", label: "Full Time" },
  ],
  highlightsUrl: "https://www.youtube.com/watch?v=jXQC7hLnkr4",
  matchStats: {
    home: { metresMade: 0, carries: 0, defendersBeaten: 0, cleanBreaks: 0, offloads: 0, tacklesMade: 0, tacklesMissed: 0, turnoversWon: 0, penaltiesConceded: 0 },
    away: { metresMade: 0, carries: 0, defendersBeaten: 0, cleanBreaks: 0, offloads: 0, tacklesMade: 0, tacklesMissed: 0, turnoversWon: 0, penaltiesConceded: 0 },
  },
  performances: [
    { category: "Coach", player: "TBD", value: "Italy W" },
    { category: "Coach", player: "TBD", value: "South Africa W" },
    { category: "Captain", player: "TBD", value: "Italy W" },
    { category: "Captain", player: "TBD", value: "South Africa W" },
    { category: "Venue", player: "Stadio Omero Tognon", value: "Fontanafredda" },
  ],
},
{
  matchKey: "england-w-vs-new-zealand-w",
  timeline: [
    { minute: "0'", label: "Kick-off — Allianz Stadium, Twickenham" },
    { minute: "40'", label: "Half Time" },
    { minute: "80'", label: "Full Time" },
  ],
  highlightsUrl: "https://www.youtube.com/watch?v=0PYaLj0q3YI",
  matchStats: {
    home: { metresMade: 0, carries: 0, defendersBeaten: 0, cleanBreaks: 0, offloads: 0, tacklesMade: 0, tacklesMissed: 0, turnoversWon: 0, penaltiesConceded: 0 },
    away: { metresMade: 0, carries: 0, defendersBeaten: 0, cleanBreaks: 0, offloads: 0, tacklesMade: 0, tacklesMissed: 0, turnoversWon: 0, penaltiesConceded: 0 },
  },
  lineups: {
    homeStarting: [
      { number: 1, name: "Mackenzie Carson" },
      { number: 2, name: "Bryony Field" },
      { number: 3, name: "Sarah Bern" },
      { number: 4, name: "Morwenna Talling" },
      { number: 5, name: "Lilli Ives Campion" },
      { number: 6, name: "Alex Matthews" },
      { number: 7, name: "Sadia Kabeya" },
      { number: 8, name: "Maddie Feaunati" },
      { number: 9, name: "Lucy Packer" },
      { number: 10, name: "Zoe Harrison" },
      { number: 11, name: "Claudia Moloney-MacDonald" },
      { number: 12, name: "Helena Rowland" },
      { number: 13, name: "Megan Jones (C)" },
      { number: 14, name: "Jess Breach" },
      { number: 15, name: "Ellie Kildunne" },
    ],
    homeBench: [
      { number: 16, name: "May Campbell" },
      { number: 17, name: "Hannah Botterman" },
      { number: 18, name: "Maud Muir" },
      { number: 19, name: "Abi Burton" },
      { number: 20, name: "Marlie Packer" },
      { number: 21, name: "Natasha Hunt" },
      { number: 22, name: "Tatyana Heard" },
      { number: 23, name: "Emma Sing" },
    ],
    awayStarting: [
      { number: 1, name: "Chryss Viliko" },
      { number: 2, name: "Georgia Ponsonby (C)" },
      { number: 3, name: "Veisinia Mahutariki-Fakalelu" },
      { number: 4, name: "Maiakawanakaulani Roos" },
      { number: 5, name: "Laura Bayfield" },
      { number: 6, name: "Liana Mikaele-Tu'u" },
      { number: 7, name: "Elinor-Plum King" },
      { number: 8, name: "Kaipo Olsen-Baker" },
      { number: 9, name: "Maia Joseph" },
      { number: 10, name: "Hannah King" },
      { number: 11, name: "Ayesha Leti-I'iga" },
      { number: 12, name: "Amy Du Plessis" },
      { number: 13, name: "Logo-I-Pulotu Lemapu-Atai'i Sylvia Brunt" },
      { number: 14, name: "Mererangi Paul" },
      { number: 15, name: "Braxton Sorensen-McGee" },
    ],
    awayBench: [
      { number: 16, name: "Atlanta Lolohea" },
      { number: 17, name: "Maddison Robinson" },
      { number: 18, name: "Santo Taumata" },
      { number: 19, name: "Maama Mo'onia Vaipulu" },
      { number: 20, name: "Layla Sae" },
      { number: 21, name: "Tara Turner" },
      { number: 22, name: "Justine McGregor" },
      { number: 23, name: "Alena Saili" },
    ],
  },
  performances: [
    { category: "Coach", player: "John Mitchell", value: "England W" },
    { category: "Coach", player: "Whitney Hansen", value: "New Zealand W" },
    { category: "Captain", player: "TBD", value: "England W" },
    { category: "Captain", player: "TBD", value: "New Zealand W" },
    { category: "Venue", player: "Allianz Stadium", value: "Twickenham" },
  ],
},
{
  matchKey: "wales-w-vs-usa-w",
  timeline: [
    { minute: "0'", label: "Kick-off — Cardiff Arms Park, Cardiff" },
    { minute: "40'", label: "Half Time" },
    { minute: "80'", label: "Full Time" },
  ],
  highlightsUrl: "https://www.youtube.com/watch?v=oHsHW1cdgPg",
  matchStats: {
    home: { metresMade: 0, carries: 0, defendersBeaten: 0, cleanBreaks: 0, offloads: 0, tacklesMade: 0, tacklesMissed: 0, turnoversWon: 0, penaltiesConceded: 0 },
    away: { metresMade: 0, carries: 0, defendersBeaten: 0, cleanBreaks: 0, offloads: 0, tacklesMade: 0, tacklesMissed: 0, turnoversWon: 0, penaltiesConceded: 0 },
  },
  lineups: {
    homeStarting: [
      { number: 1, name: "Maisie Davies" },
      { number: 2, name: "Kelsey Jones" },
      { number: 3, name: "Sisilia Tuipulotu" },
      { number: 4, name: "Branwen Metcalfe" },
      { number: 5, name: "Georgia Evans" },
      { number: 6, name: "Kate Williams (C)" },
      { number: 7, name: "Alex Callender (C)" },
      { number: 8, name: "Bryonie King" },
      { number: 9, name: "Keira Bevan" },
      { number: 10, name: "Lleucu George" },
      { number: 11, name: "Amy Williams" },
      { number: 12, name: "Freya Bell" },
      { number: 13, name: "Courtney Keight" },
      { number: 14, name: "Carys Cox" },
      { number: 15, name: "Lisa Neumann" },
    ],
    homeBench: [
      { number: 16, name: "Molly Reardon" },
      { number: 17, name: "Gwenllian Pyrs" },
      { number: 18, name: "Elan Jones" },
      { number: 19, name: "Gwen Crabb" },
      { number: 20, name: "Jorja Aiono" },
      { number: 21, name: "Sian Jones" },
      { number: 22, name: "Jenna De Vera" },
      { number: 23, name: "Nikita Prothero" },
    ],
    awayStarting: [
      { number: 1, name: "Hope Rogers" },
      { number: 2, name: "Kathryn Treder" },
      { number: 3, name: "Keia Mae Sagapolu-Senele" },
      { number: 4, name: "Hallie Taufoou" },
      { number: 5, name: "Rachel Ehrecke" },
      { number: 6, name: "Hann Humphreys" },
      { number: 7, name: "Georgie Perris-Redding (C)" },
      { number: 8, name: "Freda Tafuna" },
      { number: 9, name: "Abigail Paton" },
      { number: 10, name: "Nina Mason" },
      { number: 11, name: "Erica Coulibaly" },
      { number: 12, name: "Bella Vogel" },
      { number: 13, name: "Emily Henrich" },
      { number: 14, name: "Telesi Uhatafe" },
      { number: 15, name: "Kayla Canett" },
    ],
    awayBench: [
      { number: 16, name: "Chloe Hill-Huse" },
      { number: 17, name: "Alivia Leatherman" },
      { number: 18, name: "Reece Woods" },
      { number: 19, name: "Erica Jarrell-Searcy" },
      { number: 20, name: "Kapoina Bailey" },
      { number: 21, name: "Cassidy Bargell" },
      { number: 22, name: "Katana Howard" },
      { number: 23, name: "Tessa Hann" },
    ],
  },
  performances: [
    { category: "Coach", player: "Sean Lynn", value: "Wales W" },
    { category: "Coach", player: "TBD", value: "USA W" },
    { category: "Captain", player: "TBD", value: "Wales W" },
    { category: "Captain", player: "TBD", value: "USA W" },
    { category: "Venue", player: "Cardiff Arms Park", value: "Cardiff" },
  ],
},
{
  matchKey: "scotland-w-vs-australia-w",
  timeline: [
    { minute: "0'", label: "Kick-off — Hive Stadium, Edinburgh" },
    { minute: "40'", label: "Half Time" },
    { minute: "80'", label: "Full Time" },
  ],
  highlightsUrl: "https://www.youtube.com/watch?v=wxgmaINUM8g",
  matchStats: {
    home: { metresMade: 0, carries: 0, defendersBeaten: 0, cleanBreaks: 0, offloads: 0, tacklesMade: 0, tacklesMissed: 0, turnoversWon: 0, penaltiesConceded: 0 },
    away: { metresMade: 0, carries: 0, defendersBeaten: 0, cleanBreaks: 0, offloads: 0, tacklesMade: 0, tacklesMissed: 0, turnoversWon: 0, penaltiesConceded: 0 },
  },
  lineups: {
    homeStarting: [
      { number: 1, name: "Anne Young" },
      { number: 2, name: "Lana Skeldon" },
      { number: 3, name: "Elliann Clarke" },
      { number: 4, name: "Holland Bogan" },
      { number: 5, name: "Sarah Bonar" },
      { number: 6, name: "Rachel Malcolm (C)" },
      { number: 7, name: "Rachel McLachlan" },
      { number: 8, name: "Evie Gallagher" },
      { number: 9, name: "Ceitidh Ainsworth" },
      { number: 10, name: "Helen Nelson" },
      { number: 11, name: "Shona Campbell" },
      { number: 12, name: "Meryl Smith" },
      { number: 13, name: "Evie Wills" },
      { number: 14, name: "Rhona Lloyd" },
      { number: 15, name: "Hannah Ramsay" },
    ],
    homeBench: [
      { number: 16, name: "Aicha Sutcliffe" },
      { number: 17, name: "Leah Bartlett" },
      { number: 18, name: "Molly Poolman" },
      { number: 19, name: "Hollie Cunningham" },
      { number: 20, name: "Eva Donaldson" },
      { number: 21, name: "Leia Brebner-Holden" },
      { number: 22, name: "Katie Buchanan" },
      { number: 23, name: "Chloe Rollie" },
    ],
    awayStarting: [
      { number: 1, name: "Brianna Hoy" },
      { number: 2, name: "Brittany Merlo" },
      { number: 3, name: "Faliki Pohiva" },
      { number: 4, name: "Kaitlan Leaney" },
      { number: 5, name: "Michaela Leonard" },
      { number: 6, name: "Pia Tapsell" },
      { number: 7, name: "Piper Duck" },
      { number: 8, name: "Siokapesi Palu Sekona (C)" },
      { number: 9, name: "Samantha Wood" },
      { number: 10, name: "Waiaria Ellis" },
      { number: 11, name: "Desiree Miller" },
      { number: 12, name: "Faitala Moleka" },
      { number: 13, name: "Georgina Friedrichs" },
      { number: 14, name: "Amelia Whitaker" },
      { number: 15, name: "Caitlyn Halse" },
    ],
    awayBench: [
      { number: 16, name: "Tania Naden" },
      { number: 17, name: "Martha Fua" },
      { number: 18, name: "Bridie O'Gorman" },
      { number: 19, name: "Jemma Bemrose" },
      { number: 20, name: "Emily Chancellor" },
      { number: 21, name: "Lily Bone" },
      { number: 22, name: "Tia Hinds" },
      { number: 23, name: "Ava Wereta" },
    ],
  },
  performances: [
    { category: "Coach", player: "TBD", value: "Scotland W" },
    { category: "Coach", player: "TBD", value: "Australia W" },
    { category: "Captain", player: "TBD", value: "Scotland W" },
    { category: "Captain", player: "TBD", value: "Australia W" },
    { category: "Venue", player: "Hive Stadium", value: "Edinburgh" },
  ],
},
{
  matchKey: "france-w-vs-canada-w",
  timeline: [
    { minute: "0'", label: "Kick-off — Stade Marcel-Deflandre, La Rochelle" },
    { minute: "40'", label: "Half Time" },
    { minute: "80'", label: "Full Time" },
  ],
  highlightsUrl: "https://www.youtube.com/watch?v=_jGbbMXa-9g",
  matchStats: {
    home: { metresMade: 0, carries: 0, defendersBeaten: 0, cleanBreaks: 0, offloads: 0, tacklesMade: 0, tacklesMissed: 0, turnoversWon: 0, penaltiesConceded: 0 },
    away: { metresMade: 0, carries: 0, defendersBeaten: 0, cleanBreaks: 0, offloads: 0, tacklesMade: 0, tacklesMissed: 0, turnoversWon: 0, penaltiesConceded: 0 },
  },
  performances: [
    { category: "Coach", player: "François Ratier", value: "France W" },
    { category: "Coach", player: "TBD", value: "Canada W" },
    { category: "Captain", player: "Pauline Bourdon Sansus", value: "France W" },
    { category: "Captain", player: "TBD", value: "Canada W" },
    { category: "Venue", player: "Stade Marcel-Deflandre", value: "La Rochelle" },
  ],
},
{
  matchKey: "ireland-w-vs-japan-w",
  timeline: [
    { minute: "0'", label: "Kick-off — Dexcom Stadium, Galway" },
    { minute: "40'", label: "Half Time" },
    { minute: "80'", label: "Full Time" },
  ],
  highlightsUrl: "https://www.youtube.com/watch?v=OeWTSrwDwd8",
  matchStats: {
    home: { metresMade: 0, carries: 0, defendersBeaten: 0, cleanBreaks: 0, offloads: 0, tacklesMade: 0, tacklesMissed: 0, turnoversWon: 0, penaltiesConceded: 0 },
    away: { metresMade: 0, carries: 0, defendersBeaten: 0, cleanBreaks: 0, offloads: 0, tacklesMade: 0, tacklesMissed: 0, turnoversWon: 0, penaltiesConceded: 0 },
  },
  performances: [
    { category: "Coach", player: "TBD", value: "Ireland W" },
    { category: "Coach", player: "TBD", value: "Japan W" },
    { category: "Captain", player: "TBD", value: "Ireland W" },
    { category: "Captain", player: "TBD", value: "Japan W" },
    { category: "Venue", player: "Dexcom Stadium", value: "Galway" },
  ],
},

// ==================================================
// WXV GLOBAL SERIES 2026 (WXV 1) — ROUND 4
// ==================================================

{
  matchKey: "canada-w-vs-england-w",
  timeline: [
    { minute: "0'", label: "Kick-off — BMO Field, Toronto" },
    { minute: "40'", label: "Half Time" },
    { minute: "80'", label: "Full Time — Canada 24–21 England" },
  ],
  highlightsUrl: "https://www.youtube.com/watch?v=x4r7Cp9EE-4",
  matchStats: {
    home: { metresMade: 0, carries: 0, defendersBeaten: 0, cleanBreaks: 0, offloads: 0, tacklesMade: 0, tacklesMissed: 0, turnoversWon: 0, penaltiesConceded: 0 },
    away: { metresMade: 0, carries: 0, defendersBeaten: 0, cleanBreaks: 0, offloads: 0, tacklesMade: 0, tacklesMissed: 0, turnoversWon: 0, penaltiesConceded: 0 },
  },
  performances: [
    { category: "Coach", player: "Kevin Rouet", value: "Canada" },
    { category: "Coach", player: "John Mitchell", value: "England" },
    { category: "Captain", player: "Sophie de Goede", value: "Canada" },
    { category: "Captain", player: "TBD", value: "England" },
    { category: "Venue", player: "BMO Field", value: "Toronto" },
    { category: "Note", player: "Canada", value: "Ended England’s 41-match unbeaten run" },
  ],
},

{
  matchKey: "australia-w-vs-scotland-w",
  timeline: [
    { minute: "0'", label: "Kick-off — Stadium Australia, Sydney" },
    { minute: "40'", label: "Half Time — Australia 35–5 Scotland" },
    { minute: "80'", label: "Full Time — Australia 56–12 Scotland" },
  ],
  highlightsUrl: "https://www.youtube.com/watch?v=VPra6F2uFMc",
  matchStats: {
    home: { metresMade: 0, carries: 0, defendersBeaten: 0, cleanBreaks: 0, offloads: 0, tacklesMade: 0, tacklesMissed: 0, turnoversWon: 0, penaltiesConceded: 0 },
    away: { metresMade: 0, carries: 0, defendersBeaten: 0, cleanBreaks: 0, offloads: 0, tacklesMade: 0, tacklesMissed: 0, turnoversWon: 0, penaltiesConceded: 0 },
  },
  performances: [
    { category: "Coach", player: "TBD", value: "Australia" },
    { category: "Coach", player: "TBD", value: "Scotland" },
    { category: "Captain", player: "TBD", value: "Australia" },
    { category: "Captain", player: "Rachel Malcolm", value: "Scotland" },
    { category: "Venue", player: "Stadium Australia", value: "Sydney" },
  ],
},

{
  matchKey: "new-zealand-w-vs-france-w",
  timeline: [
    { minute: "0'", label: "Kick-off — FMG Stadium Waikato, Hamilton" },
    { minute: "40'", label: "Half Time" },
    { minute: "80'", label: "Full Time — New Zealand 81–12 France" },
  ],
  highlightsUrl: "https://www.youtube.com/watch?v=8s8ssvpJ40A",
  matchStats: {
    home: { metresMade: 0, carries: 0, defendersBeaten: 0, cleanBreaks: 0, offloads: 0, tacklesMade: 0, tacklesMissed: 0, turnoversWon: 0, penaltiesConceded: 0 },
    away: { metresMade: 0, carries: 0, defendersBeaten: 0, cleanBreaks: 0, offloads: 0, tacklesMade: 0, tacklesMissed: 0, turnoversWon: 0, penaltiesConceded: 0 },
  },
  performances: [
    { category: "Coach", player: "Whitney Hansen", value: "New Zealand" },
    { category: "Coach", player: "François Ratier", value: "France" },
    { category: "Captain", player: "Georgia Ponsonby", value: "New Zealand" },
    { category: "Captain", player: "TBD", value: "France" },
    { category: "Venue", player: "FMG Stadium Waikato", value: "Hamilton" },
  ],
},

{
  matchKey: "usa-w-vs-italy-w",
  timeline: [
    { minute: "0'", label: "Kick-off — Texas Health Mansfield Stadium, Mansfield" },
    { minute: "40'", label: "Half Time" },
    { minute: "80'", label: "Full Time — USA 36–27 Italy" },
  ],
  highlightsUrl: "https://www.youtube.com/watch?v=tGVrRVXqYhE",
  matchStats: {
    home: { metresMade: 0, carries: 0, defendersBeaten: 0, cleanBreaks: 0, offloads: 0, tacklesMade: 0, tacklesMissed: 0, turnoversWon: 0, penaltiesConceded: 0 },
    away: { metresMade: 0, carries: 0, defendersBeaten: 0, cleanBreaks: 0, offloads: 0, tacklesMade: 0, tacklesMissed: 0, turnoversWon: 0, penaltiesConceded: 0 },
  },
  performances: [
    { category: "Coach", player: "TBD", value: "USA" },
    { category: "Coach", player: "TBD", value: "Italy" },
    { category: "Captain", player: "TBD", value: "USA" },
    { category: "Captain", player: "TBD", value: "Italy" },
    { category: "Venue", player: "Mansfield Stadium", value: "Texas" },
  ],
},

// ==================================================
// WXV GLOBAL SERIES 2026 (WXV 1) — ROUND 5
// ==================================================

{
  matchKey: "australia-w-vs-scotland-w-r5",
  timeline: [
    { minute: "0'", label: "Kick-off — GIO Stadium, Canberra" },
    { minute: "40'", label: "Half Time" },
    { minute: "80'", label: "Full Time" },
  ],
  highlightsUrl: "https://www.youtube.com/watch?v=VPra6F2uFMc",
  matchStats: {
    home: { metresMade: 0, carries: 0, defendersBeaten: 0, cleanBreaks: 0, offloads: 0, tacklesMade: 0, tacklesMissed: 0, turnoversWon: 0, penaltiesConceded: 0 },
    away: { metresMade: 0, carries: 0, defendersBeaten: 0, cleanBreaks: 0, offloads: 0, tacklesMade: 0, tacklesMissed: 0, turnoversWon: 0, penaltiesConceded: 0 },
  },
  performances: [
    { category: "Coach", player: "TBD", value: "Australia" },
    { category: "Coach", player: "TBD", value: "Scotland" },
    { category: "Venue", player: "GIO Stadium", value: "Canberra" },
  ],
},

{
  matchKey: "canada-w-vs-england-w-r5",
  timeline: [
    { minute: "0'", label: "Kick-off — TD Place Stadium, Ottawa" },
    { minute: "40'", label: "Half Time" },
    { minute: "80'", label: "Full Time" },
  ],
  highlightsUrl: "https://www.youtube.com/watch?v=bXTc5sgDRlc",
  matchStats: {
    home: { metresMade: 0, carries: 0, defendersBeaten: 0, cleanBreaks: 0, offloads: 0, tacklesMade: 0, tacklesMissed: 0, turnoversWon: 0, penaltiesConceded: 0 },
    away: { metresMade: 0, carries: 0, defendersBeaten: 0, cleanBreaks: 0, offloads: 0, tacklesMade: 0, tacklesMissed: 0, turnoversWon: 0, penaltiesConceded: 0 },
  },
  performances: [
    { category: "Coach", player: "Kevin Rouet", value: "Canada" },
    { category: "Coach", player: "John Mitchell", value: "England" },
    { category: "Venue", player: "TD Place Stadium", value: "Ottawa" },
  ],
},

{
  matchKey: "new-zealand-w-vs-france-w-r5",
  timeline: [
    { minute: "0'", label: "Kick-off — Whangārei" },
    { minute: "40'", label: "Half Time" },
    { minute: "80'", label: "Full Time" },
  ],
  highlightsUrl: "https://www.youtube.com/watch?v=4QkQTkTvaxQ",
  matchStats: {
    home: { metresMade: 0, carries: 0, defendersBeaten: 0, cleanBreaks: 0, offloads: 0, tacklesMade: 0, tacklesMissed: 0, turnoversWon: 0, penaltiesConceded: 0 },
    away: { metresMade: 0, carries: 0, defendersBeaten: 0, cleanBreaks: 0, offloads: 0, tacklesMade: 0, tacklesMissed: 0, turnoversWon: 0, penaltiesConceded: 0 },
  },
  performances: [
    { category: "Coach", player: "Whitney Hansen", value: "New Zealand" },
    { category: "Coach", player: "François Ratier", value: "France" },
    { category: "Venue", player: "Whangārei", value: "New Zealand" },
  ],
},

{
  matchKey: "japan-w-vs-wales-w-r5",
  timeline: [
    { minute: "0'", label: "Kick-off — Prince Chichibu Memorial Stadium, Tokyo" },
    { minute: "40'", label: "Half Time" },
    { minute: "80'", label: "Full Time" },
  ],
  highlightsUrl: "https://www.youtube.com/watch?v=74avqhmewhA",
  matchStats: {
    home: { metresMade: 0, carries: 0, defendersBeaten: 0, cleanBreaks: 0, offloads: 0, tacklesMade: 0, tacklesMissed: 0, turnoversWon: 0, penaltiesConceded: 0 },
    away: { metresMade: 0, carries: 0, defendersBeaten: 0, cleanBreaks: 0, offloads: 0, tacklesMade: 0, tacklesMissed: 0, turnoversWon: 0, penaltiesConceded: 0 },
  },
  performances: [
    { category: "Coach", player: "TBD", value: "Japan" },
    { category: "Coach", player: "TBD", value: "Wales" },
    { category: "Venue", player: "Prince Chichibu Memorial Stadium", value: "Tokyo" },
  ],
},

{
  matchKey: "south-africa-w-vs-ireland-w-r5",
  timeline: [
    { minute: "0'", label: "Kick-off — Athlone Stadium, Cape Town" },
    { minute: "40'", label: "Half Time" },
    { minute: "80'", label: "Full Time" },
  ],
  highlightsUrl: "https://www.youtube.com/watch?v=ogVSgw7AiVE&t=7742s",
  matchStats: {
    home: { metresMade: 0, carries: 0, defendersBeaten: 0, cleanBreaks: 0, offloads: 0, tacklesMade: 0, tacklesMissed: 0, turnoversWon: 0, penaltiesConceded: 0 },
    away: { metresMade: 0, carries: 0, defendersBeaten: 0, cleanBreaks: 0, offloads: 0, tacklesMade: 0, tacklesMissed: 0, turnoversWon: 0, penaltiesConceded: 0 },
  },
  performances: [
    { category: "Coach", player: "TBD", value: "South Africa" },
    { category: "Coach", player: "Scott Bemand", value: "Ireland" },
    { category: "Venue", player: "Athlone Stadium", value: "Cape Town" },
  ],
},

{
  matchKey: "usa-w-vs-italy-w-r5",
  timeline: [
    { minute: "0'", label: "Kick-off — Geodis Park, Nashville" },
    { minute: "40'", label: "Half Time" },
    { minute: "80'", label: "Full Time" },
  ],
  highlightsUrl: "",
  matchStats: {
    home: { metresMade: 0, carries: 0, defendersBeaten: 0, cleanBreaks: 0, offloads: 0, tacklesMade: 0, tacklesMissed: 0, turnoversWon: 0, penaltiesConceded: 0 },
    away: { metresMade: 0, carries: 0, defendersBeaten: 0, cleanBreaks: 0, offloads: 0, tacklesMade: 0, tacklesMissed: 0, turnoversWon: 0, penaltiesConceded: 0 },
  },
  performances: [
    { category: "Coach", player: "TBD", value: "USA" },
    { category: "Coach", player: "TBD", value: "Italy" },
    { category: "Venue", player: "Geodis Park", value: "Nashville" },
  ],
},

// ==================================================
// WXV GLOBAL SERIES 2026 – ROUND 6
// ==================================================

{
  matchKey: "usa-w-vs-england-w",
  timeline: [
    { minute: "0'", label: "Kick-off — Sports Illustrated Stadium, Harrison" },
    { minute: "40'", label: "Half Time — USA 7–17 England" },
    { minute: "80'", label: "Full Time — USA 12–55 England" },
  ],
  highlightsUrl: "https://www.youtube.com/watch?v=nCfjj99dBzA",
  matchStats: {
    home: { metresMade: 0, carries: 0, defendersBeaten: 0, cleanBreaks: 0, offloads: 0, tacklesMade: 0, tacklesMissed: 0, turnoversWon: 0, penaltiesConceded: 0 },
    away: { metresMade: 0, carries: 0, defendersBeaten: 0, cleanBreaks: 0, offloads: 0, tacklesMade: 0, tacklesMissed: 0, turnoversWon: 0, penaltiesConceded: 0 },
  },
  performances: [
    { category: "Coach", player: "TBD", value: "USA" },
    { category: "Coach", player: "John Mitchell", value: "England" },
    { category: "Captain", player: "TBD", value: "USA" },
    { category: "Captain", player: "TBD", value: "England" },
    { category: "Player of the Match", player: "Claudia Moloney-MacDonald", value: "England (4 tries)" },
    { category: "Note", player: "England", value: "9 tries scored" },
    { category: "Venue", player: "Sports Illustrated Stadium", value: "Harrison, New Jersey" },
  ],
},

{
  matchKey: "new-zealand-w-vs-france-w",
  timeline: [
    { minute: "0'", label: "Kick-off — One New Zealand Stadium, Christchurch" },
    { minute: "40'", label: "Half Time" },
    { minute: "80'", label: "Full Time — New Zealand 36–7 France" },
  ],
  highlightsUrl: "https://www.youtube.com/watch?v=pfv5GMDarZg",
  matchStats: {
    home: { metresMade: 0, carries: 0, defendersBeaten: 0, cleanBreaks: 0, offloads: 0, tacklesMade: 0, tacklesMissed: 0, turnoversWon: 0, penaltiesConceded: 0 },
    away: { metresMade: 0, carries: 0, defendersBeaten: 0, cleanBreaks: 0, offloads: 0, tacklesMade: 0, tacklesMissed: 0, turnoversWon: 0, penaltiesConceded: 0 },
  },
  performances: [
    { category: "Coach", player: "Whitney Hansen", value: "New Zealand" },
    { category: "Coach", player: "François Ratier", value: "France" },
    { category: "Captain", player: "Georgia Ponsonby", value: "New Zealand" },
    { category: "Captain", player: "Pauline Bourdon Sansus", value: "France" },
    { category: "Note", player: "New Zealand", value: "Completed clean-sweep over France" },
    { category: "Venue", player: "One New Zealand Stadium", value: "Christchurch" },
  ],
},

{
  matchKey: "japan-w-vs-wales-w",
  timeline: [
    { minute: "0'", label: "Kick-off — Kumagaya Rugby Stadium, Kumagaya" },
    { minute: "40'", label: "Half Time — Japan 5–19 Wales" },
    { minute: "80'", label: "Full Time — Japan 5–29 Wales" },
  ],
  highlightsUrl: "https://www.youtube.com/watch?v=iTDcb-ItEHk",
  matchStats: {
    home: { metresMade: 0, carries: 0, defendersBeaten: 0, cleanBreaks: 0, offloads: 0, tacklesMade: 0, tacklesMissed: 0, turnoversWon: 0, penaltiesConceded: 0 },
    away: { metresMade: 0, carries: 0, defendersBeaten: 0, cleanBreaks: 0, offloads: 0, tacklesMade: 0, tacklesMissed: 0, turnoversWon: 0, penaltiesConceded: 0 },
  },
  performances: [
    { category: "Coach", player: "TBD", value: "Japan" },
    { category: "Coach", player: "TBD", value: "Wales" },
    { category: "Captain", player: "TBD", value: "Japan" },
    { category: "Captain", player: "TBD", value: "Wales" },
    { category: "Note", player: "Wales", value: "Completed double over Japan" },
    { category: "Venue", player: "Kumagaya Rugby Stadium", value: "Kumagaya" },
  ],
},

{
  matchKey: "south-africa-w-vs-ireland-w",
  timeline: [
    { minute: "0'", label: "Kick-off — Athlone Stadium, Cape Town" },
    { minute: "40'", label: "Half Time — South Africa 10–14 Ireland" },
    { minute: "80'", label: "Full Time — South Africa 17–38 Ireland" },
  ],
  highlightsUrl: "https://www.youtube.com/watch?v=XULpGZ9WlqM",
  matchStats: {
    home: { metresMade: 0, carries: 0, defendersBeaten: 0, cleanBreaks: 0, offloads: 0, tacklesMade: 0, tacklesMissed: 0, turnoversWon: 0, penaltiesConceded: 0 },
    away: { metresMade: 0, carries: 0, defendersBeaten: 0, cleanBreaks: 0, offloads: 0, tacklesMade: 0, tacklesMissed: 0, turnoversWon: 0, penaltiesConceded: 0 },
  },
  performances: [
    { category: "Coach", player: "TBD", value: "South Africa" },
    { category: "Coach", player: "Scott Bemand", value: "Ireland" },
    { category: "Captain", player: "TBD", value: "South Africa" },
    { category: "Captain", player: "TBD", value: "Ireland" },
    { category: "Player of the Match", player: "Beibhinn Parsons", value: "Ireland (hat-trick)" },
    { category: "Note", player: "Ireland", value: "Series win over South Africa (2-0)" },
    { category: "Venue", player: "Athlone Stadium", value: "Cape Town" },
  ],
},

  // ==================================================
// WXV GLOBAL SERIES CHALLENGER 2026 — ROUND 1
// ==================================================

{
  matchKey: "spain-w-vs-fiji-w",
  highlightsUrl: "https://www.youtube.com/watch?v=BSQfJXckm0A",
  matchStats: {
    home: {
      metresMade: 380,
      carries: 120,
      defendersBeaten: 22,
      cleanBreaks: 7,
      offloads: 8,
      tacklesMade: 140,
      tacklesMissed: 30,
      turnoversWon: 7,
      penaltiesConceded: 11,
    },
    away: {
      metresMade: 410,
      carries: 130,
      defendersBeaten: 28,
      cleanBreaks: 9,
      offloads: 11,
      tacklesMade: 135,
      tacklesMissed: 25,
      turnoversWon: 8,
      penaltiesConceded: 10,
    },
  },
  timeline: [
    { minute: "0'", label: "Kick-off — Kai Tak Youth Sports Ground, Hong Kong" },
    { minute: "40'", label: "Half Time" },
    { minute: "80'", label: "Full Time" },
  ],
lineups: {
    homeStarting: [
      { number: 1, name: "Gemma Silva" },
      { number: 2, name: "Nuria Jou" },
      { number: 3, name: "Eider García" },
      { number: 4, name: "Beatriz Rivera" },
      { number: 5, name: "Lourdes Alameda (C)" },
      { number: 6, name: "Victoria Rosell" },
      { number: 7, name: "Nerea García" },
      { number: 8, name: "Valentina Pérez" },
      { number: 9, name: "Bingbing Vergara" },
      { number: 10, name: "Naroa Azpitarte" },
      { number: 11, name: "Ana Cortés Ekobo" },
      { number: 12, name: "Maider Aresti" },
      { number: 13, name: "Amaia Erbina" },
      { number: 14, name: "Claudia Cano" },
      { number: 15, name: "Amalia Argudo" },
    ],
    homeBench: [
      { number: 16, name: "Alba Capell" },
      { number: 17, name: "África Vílchez" },
      { number: 18, name: "Sidorella Bracic" },
      { number: 19, name: "Carmen Castellucci" },
      { number: 20, name: "Carmen Nwatu" },
      { number: 21, name: "Matilda Toca" },
      { number: 22, name: "Anne Fernández de Corres" },
      { number: 23, name: "Claudia Peña" },
    ],
    awayStarting: [
      { number: 1, name: "Karalaini Naisewa" },
      { number: 2, name: "Keleni Marawa" },
      { number: 3, name: "Tiana Rovanakadavu" },
      { number: 4, name: "Jade Coates" },
      { number: 5, name: "Mereoni Nakesa" },
      { number: 6, name: "Nunia Daunimoala" },
      { number: 7, name: "Merewairita Neivoha" },
      { number: 8, name: "Alfreda Fisher" },
      { number: 9, name: "Kolora Lomani (C)" },
      { number: 10, name: "Varanisese Qoro" },
      { number: 11, name: "Aqela Raitubu" },
      { number: 12, name: "Josivini Neihamu" },
      { number: 13, name: "Ruth Raketekete" },
      { number: 14, name: "Atelaite Ralivanawa" },
      { number: 15, name: "Ivamere Rokowati" },
    ],
    awayBench: [
      { number: 16, name: "Bitila Tawake" },
      { number: 17, name: "Zipporah Sorokaciva" },
      { number: 18, name: "Keri Lawavou" },
      { number: 19, name: "Carletta Yee" },
      { number: 20, name: "Manuqalo Komaitai" },
      { number: 21, name: "Evivi Sanikarivi" },
      { number: 22, name: "Salote Nailolo" },
      { number: 23, name: "Repeka Tove" },
    ],
  },
  performances: [
    { category: "Coach", player: "Régis Sonnes", value: "Spain W" },
    { category: "Coach", player: "Willie Walker", value: "Fiji W" },
    { category: "Captain", player: "Lourdes Alameda", value: "Spain W" },
    { category: "Captain", player: "Kolora Lomani", value: "Fiji W" },
    { category: "Venue", player: "Kai Tak Youth Sports Ground", value: "Hong Kong" },
  ],
},

{
  matchKey: "hong-kong-china-w-vs-brazil-w",
  highlightsUrl: "https://www.youtube.com/watch?v=0hck3vVpjxg",
  matchStats: {
    home: {
      metresMade: 340,
      carries: 115,
      defendersBeaten: 20,
      cleanBreaks: 6,
      offloads: 7,
      tacklesMade: 130,
      tacklesMissed: 22,
      turnoversWon: 9,
      penaltiesConceded: 9,
    },
    away: {
      metresMade: 310,
      carries: 108,
      defendersBeaten: 18,
      cleanBreaks: 5,
      offloads: 6,
      tacklesMade: 140,
      tacklesMissed: 24,
      turnoversWon: 6,
      penaltiesConceded: 10,
    },
  },
  timeline: [
    { minute: "0'", label: "Kick-off — Kai Tak Youth Sports Ground, Hong Kong" },
    { minute: "40'", label: "Half Time" },
    { minute: "80'", label: "Full Time" },
  ],
  performances: [
    { category: "Coach", player: "Tumua Ioane", value: "Hong Kong China W" },
    { category: "Coach", player: "Guilherme Coghetto", value: "Brazil W" },
    { category: "Captain", player: "Lara Schats", value: "Hong Kong China W" },
    { category: "Captain", player: "Luiza Campos", value: "Brazil W" },
    { category: "Venue", player: "Kai Tak Youth Sports Ground", value: "Hong Kong" },
  ],
},

{
  matchKey: "netherlands-w-vs-samoa-w",
  highlightsUrl: "https://www.youtube.com/watch?v=Av9J9GWwNGM",
  matchStats: {
    home: {
      metresMade: 550,
      carries: 140,
      defendersBeaten: 35,
      cleanBreaks: 13,
      offloads: 10,
      tacklesMade: 85,
      tacklesMissed: 12,
      turnoversWon: 11,
      penaltiesConceded: 6,
    },
    away: {
      metresMade: 180,
      carries: 70,
      defendersBeaten: 8,
      cleanBreaks: 1,
      offloads: 3,
      tacklesMade: 160,
      tacklesMissed: 40,
      turnoversWon: 3,
      penaltiesConceded: 14,
    },
  },
  timeline: [
    { minute: "0'", label: "Kick-off — Kai Tak Youth Sports Ground, Hong Kong" },
    { minute: "40'", label: "Half Time" },
    { minute: "80'", label: "Full Time" },
  ],
  performances: [
    { category: "Coach", player: "Gareth Gilbert", value: "Netherlands W" },
    { category: "Coach", player: "TBD", value: "Samoa W" },
    { category: "Captain", player: "TBD", value: "Netherlands W" },
    { category: "Captain", player: "TBD", value: "Samoa W" },
    { category: "Venue", player: "Kai Tak Youth Sports Ground", value: "Hong Kong" },
  ],
},

// ==================================================
// WXV GLOBAL SERIES CHALLENGER 2026 — ROUND 2
// ==================================================

{
  matchKey: "samoa-w-vs-spain-w",
  highlightsUrl: "https://www.youtube.com/watch?v=hpGh-Z_j88E",
  timeline: [
    { minute: "0'", label: "Kick-off — Kai Tak Youth Sports Ground, Hong Kong" },
    { minute: "40'", label: "Half Time" },
    { minute: "80'", label: "Full Time" },
  ],
  performances: [
    { category: "Coach", player: "TBD", value: "Samoa W" },
    { category: "Coach", player: "Régis Sonnes", value: "Spain W" },
    { category: "Captain", player: "TBD", value: "Samoa W" },
    { category: "Captain", player: "Lourdes Alameda", value: "Spain W" },
    { category: "Venue", player: "Kai Tak Youth Sports Ground", value: "Hong Kong" },
  ],
},
{
  matchKey: "fiji-w-vs-hong-kong-china-w",
  highlightsUrl: "https://www.youtube.com/watch?v=ns978KpRWO8",
  timeline: [
    { minute: "0'", label: "Kick-off — Kai Tak Youth Sports Ground, Hong Kong" },
    { minute: "40'", label: "Half Time" },
    { minute: "80'", label: "Full Time" },
  ],
  lineups: {
    homeStarting: [
      { number: 1, name: "Karalaini Naisewa" },
      { number: 2, name: "Keleni Marawa" },
      { number: 3, name: "Tiana Rovanakadavu" },
      { number: 4, name: "Jade Coates" },
      { number: 5, name: "Mereoni Nakesa" },
      { number: 6, name: "Nunia Daunimoala" },
      { number: 7, name: "Merewairita Neivoha" },
      { number: 8, name: "Alfreda Fisher" },
      { number: 9, name: "Kolora Lomani (C)" },
      { number: 10, name: "Varanisese Qoro" },
      { number: 11, name: "Aqela Raitubu" },
      { number: 12, name: "Josivini Neihamu" },
      { number: 13, name: "Ruth Raketekete" },
      { number: 14, name: "Atelaite Ralivanawa" },
      { number: 15, name: "Ivamere Rokowati" },
    ],
    homeBench: [
      { number: 16, name: "Bitila Tawake" },
      { number: 17, name: "Zipporah Sorokaciva" },
      { number: 18, name: "Keri Lawavou" },
      { number: 19, name: "Carletta Yee" },
      { number: 20, name: "Manuqalo Komaitai" },
      { number: 21, name: "Evivi Sanikarivi" },
      { number: 22, name: "Salote Nailolo" },
      { number: 23, name: "Repeka Tove" },
    ],
    awayStarting: [
      { number: 1, name: "Lau Nga Wun" },
      { number: 2, name: "Tanya Dhar" },
      { number: 3, name: "Kirstie Stevenson" },
      { number: 4, name: "Chloe Baltazar" },
      { number: 5, name: "Roshini Turner" },
      { number: 6, name: "Jenna Potgieter" },
      { number: 7, name: "Siu Wing Ni Winnie" },
      { number: 8, name: "Grace Hood" },
      { number: 9, name: "Rosie Down" },
      { number: 10, name: "Lara Schats (C)" },
      { number: 11, name: "Lucia Bolton" },
      { number: 12, name: "Lauren Knowler" },
      { number: 13, name: "Abigail Chan" },
      { number: 14, name: "Ella Lynam" },
      { number: 15, name: "Sabay Lynam" },
    ],
    awayBench: [
      { number: 16, name: "Lam Tim Yeung Iris" },
      { number: 17, name: "Ng Ki Sum" },
      { number: 18, name: "Lee Ka Shun" },
      { number: 19, name: "Chow Mei Nam" },
      { number: 20, name: "Isobel Littlehailes" },
      { number: 21, name: "Pun Wai Yan" },
      { number: 22, name: "Wan Tsz Yau" },
      { number: 23, name: "Georgia Cutt" },
    ],
  },
  performances: [
    { category: "Coach", player: "Willie Walker", value: "Fiji W" },
    { category: "Coach", player: "Tumua Ioane", value: "Hong Kong China W" },
    { category: "Captain", player: "Kolora Lomani", value: "Fiji W" },
    { category: "Captain", player: "Lara Schats", value: "Hong Kong China W" },
    { category: "Venue", player: "Kai Tak Youth Sports Ground", value: "Hong Kong" },
  ],
},
{
  matchKey: "brazil-w-vs-netherlands-w",
  highlightsUrl: "https://www.youtube.com/watch?v=3eN3HpBnbbE",
  timeline: [
    { minute: "0'", label: "Kick-off — Kai Tak Youth Sports Ground, Hong Kong" },
    { minute: "40'", label: "Half Time" },
    { minute: "80'", label: "Full Time" },
  ],
  performances: [
    { category: "Coach", player: "Guilherme Coghetto", value: "Brazil W" },
    { category: "Coach", player: "Gareth Gilbert", value: "Netherlands W" },
    { category: "Captain", player: "Luiza Campos", value: "Brazil W" },
    { category: "Captain", player: "TBD", value: "Netherlands W" },
    { category: "Venue", player: "Kai Tak Youth Sports Ground", value: "Hong Kong" },
  ],
},

  // ==================================================
// WXV GLOBAL SERIES CHALLENGER 2026 — ROUND 3
// ==================================================

{
  matchKey: "fiji-w-vs-netherlands-w",
  timeline: [
    { minute: "0'", label: "Kick-off — Kai Tak Youth Sports Ground, Hong Kong" },
    { minute: "40'", label: "Half Time" },
    { minute: "80'", label: "Full Time" },
  ],
  highlightsUrl: "https://www.youtube.com/watch?v=TKGHDKuoae8",
  matchStats: {
    home: { metresMade: 0, carries: 0, defendersBeaten: 0, cleanBreaks: 0, offloads: 0, tacklesMade: 0, tacklesMissed: 0, turnoversWon: 0, penaltiesConceded: 0 },
    away: { metresMade: 0, carries: 0, defendersBeaten: 0, cleanBreaks: 0, offloads: 0, tacklesMade: 0, tacklesMissed: 0, turnoversWon: 0, penaltiesConceded: 0 },
  },
  lineups: {
    homeStarting: [
      { number: 1, name: "Zipporah Sorokacika" },
      { number: 2, name: "Keleni Marawa" },
      { number: 3, name: "Tiana Robanakadavu" },
      { number: 4, name: "Mereoni Nakesa" },
      { number: 5, name: "Carletta Yee" },
      { number: 6, name: "Alfreda Fisher" },
      { number: 7, name: "Merewairita Neivosa" },
      { number: 8, name: "Manuqalo Komaitai" },
      { number: 9, name: "Kolora Lomani (C)" },
      { number: 10, name: "Varanisese Qoro" },
      { number: 11, name: "Adi Salote Nailolo" },
      { number: 12, name: "Josivini Neihamu" },
      { number: 13, name: "Repeka Tove" },
      { number: 14, name: "Atelaite Buna Ralivanawa" },
      { number: 15, name: "Iva Mere Nabura" },
    ],
    homeBench: [
      { number: 16, name: "Selai Naliva" },
      { number: 17, name: "Karalaini Naisewa" },
      { number: 18, name: "Adi Keri Lawavou" },
      { number: 19, name: "Karavaki Lutumaibau" },
      { number: 20, name: "Nunia Daunimoala" },
      { number: 21, name: "Evivi Senikarivi" },
      { number: 22, name: "Litiana Vueti" },
      { number: 23, name: "Vasemaca Duva" },
    ],
    awayStarting: [
      { number: 1, name: "TBD" },
      { number: 2, name: "TBD" },
      { number: 3, name: "TBD" },
      { number: 4, name: "TBD" },
      { number: 5, name: "TBD" },
      { number: 6, name: "TBD" },
      { number: 7, name: "TBD" },
      { number: 8, name: "TBD" },
      { number: 9, name: "TBD" },
      { number: 10, name: "TBD" },
      { number: 11, name: "TBD" },
      { number: 12, name: "TBD" },
      { number: 13, name: "TBD" },
      { number: 14, name: "TBD" },
      { number: 15, name: "TBD" },
    ],
    awayBench: [
      { number: 16, name: "TBD" },
      { number: 17, name: "TBD" },
      { number: 18, name: "TBD" },
      { number: 19, name: "TBD" },
      { number: 20, name: "TBD" },
      { number: 21, name: "TBD" },
      { number: 22, name: "TBD" },
      { number: 23, name: "TBD" },
    ],
  },
  performances: [
    { category: "Coach", player: "TBD", value: "Fiji W" },
    { category: "Coach", player: "TBD", value: "Netherlands W" },
    { category: "Captain", player: "TBD", value: "Fiji W" },
    { category: "Captain", player: "TBD", value: "Netherlands W" },
    { category: "Venue", player: "Kai Tak Youth Sports Ground", value: "Hong Kong" },
  ],
},
{
  matchKey: "hong-kong-china-w-vs-samoa-w",
  timeline: [
    { minute: "0'", label: "Kick-off — Kai Tak Youth Sports Ground, Hong Kong" },
    { minute: "40'", label: "Half Time" },
    { minute: "80'", label: "Full Time" },
  ],
  highlightsUrl: "https://www.youtube.com/watch?v=FVud0lKOj2o",
  matchStats: {
    home: { metresMade: 0, carries: 0, defendersBeaten: 0, cleanBreaks: 0, offloads: 0, tacklesMade: 0, tacklesMissed: 0, turnoversWon: 0, penaltiesConceded: 0 },
    away: { metresMade: 0, carries: 0, defendersBeaten: 0, cleanBreaks: 0, offloads: 0, tacklesMade: 0, tacklesMissed: 0, turnoversWon: 0, penaltiesConceded: 0 },
  },
  lineups: {
    homeStarting: [
      { number: 1, name: "Lau Nga Wun" },
      { number: 2, name: "Tanya Dhar" },
      { number: 3, name: "Kea Herewini" },
      { number: 4, name: "Chloe Baltazar" },
      { number: 5, name: "Roshini Turner" },
      { number: 6, name: "Pun Wai Yan" },
      { number: 7, name: "Siu Wing Ni Winnie" },
      { number: 8, name: "Grace Hood" },
      { number: 9, name: "TBD" },
      { number: 10, name: "TBD" },
      { number: 11, name: "TBD" },
      { number: 12, name: "TBD" },
      { number: 13, name: "TBD" },
      { number: 14, name: "TBD" },
      { number: 15, name: "TBD" },
    ],
    homeBench: [
      { number: 16, name: "TBD" },
      { number: 17, name: "TBD" },
      { number: 18, name: "TBD" },
      { number: 19, name: "TBD" },
      { number: 20, name: "TBD" },
      { number: 21, name: "TBD" },
      { number: 22, name: "TBD" },
      { number: 23, name: "TBD" },
    ],
    awayStarting: [
      { number: 1, name: "TBD" },
      { number: 2, name: "TBD" },
      { number: 3, name: "TBD" },
      { number: 4, name: "TBD" },
      { number: 5, name: "TBD" },
      { number: 6, name: "TBD" },
      { number: 7, name: "TBD" },
      { number: 8, name: "TBD" },
      { number: 9, name: "TBD" },
      { number: 10, name: "TBD" },
      { number: 11, name: "TBD" },
      { number: 12, name: "TBD" },
      { number: 13, name: "TBD" },
      { number: 14, name: "TBD" },
      { number: 15, name: "TBD" },
    ],
    awayBench: [
      { number: 16, name: "TBD" },
      { number: 17, name: "TBD" },
      { number: 18, name: "TBD" },
      { number: 19, name: "TBD" },
      { number: 20, name: "TBD" },
      { number: 21, name: "TBD" },
      { number: 22, name: "TBD" },
      { number: 23, name: "TBD" },
    ],
  },
  performances: [
    { category: "Coach", player: "Tumua Ioane", value: "Hong Kong China W" },
    { category: "Coach", player: "TBD", value: "Samoa W" },
    { category: "Captain", player: "TBD", value: "Hong Kong China W" },
    { category: "Captain", player: "TBD", value: "Samoa W" },
    { category: "Venue", player: "Kai Tak Youth Sports Ground", value: "Hong Kong" },
  ],
},
{
  matchKey: "spain-w-vs-brazil-w",
  timeline: [
    { minute: "0'", label: "Kick-off — Kai Tak Youth Sports Ground, Hong Kong" },
    { minute: "40'", label: "Half Time" },
    { minute: "80'", label: "Full Time" },
  ],
  highlightsUrl: "",
  matchStats: {
    home: { metresMade: 0, carries: 0, defendersBeaten: 0, cleanBreaks: 0, offloads: 0, tacklesMade: 0, tacklesMissed: 0, turnoversWon: 0, penaltiesConceded: 0 },
    away: { metresMade: 0, carries: 0, defendersBeaten: 0, cleanBreaks: 0, offloads: 0, tacklesMade: 0, tacklesMissed: 0, turnoversWon: 0, penaltiesConceded: 0 },
  },
  lineups: {
    homeStarting: [
      { number: 1, name: "Inés Antolínez" },
      { number: 2, name: "Nuria Jou" },
      { number: 3, name: "Eider García" },
      { number: 4, name: "Carmen Castellucci" },
      { number: 5, name: "Lourdes Alameda" },
      { number: 6, name: "Nerea García" },
      { number: 7, name: "Carmen Nwatu" },
      { number: 8, name: "Valentina Pérez" },
      { number: 9, name: "Matilda Toca" },
      { number: 10, name: "Naroa Azpitarte" },
      { number: 11, name: "Ana Cortés Ekobo" },
      { number: 12, name: "Amaia Erbina" },
      { number: 13, name: "Claudia Peña" },
      { number: 14, name: "Claudia Pérez" },
      { number: 15, name: "Amalia Argudo" },
    ],
    homeBench: [
      { number: 16, name: "María Miguel" },
      { number: 17, name: "África Vílchez" },
      { number: 18, name: "Izar Casado" },
      { number: 19, name: "Beatriz Rivera" },
      { number: 20, name: "Alba Capell" },
      { number: 21, name: "Bingbing Vergara" },
      { number: 22, name: "Anne Fernández de Corres" },
      { number: 23, name: "Claudia Cano" },
    ],
    awayStarting: [
      { number: 1, name: "TBD" },
      { number: 2, name: "TBD" },
      { number: 3, name: "TBD" },
      { number: 4, name: "TBD" },
      { number: 5, name: "TBD" },
      { number: 6, name: "TBD" },
      { number: 7, name: "TBD" },
      { number: 8, name: "TBD" },
      { number: 9, name: "TBD" },
      { number: 10, name: "TBD" },
      { number: 11, name: "TBD" },
      { number: 12, name: "TBD" },
      { number: 13, name: "TBD" },
      { number: 14, name: "TBD" },
      { number: 15, name: "TBD" },
    ],
    awayBench: [
      { number: 16, name: "TBD" },
      { number: 17, name: "TBD" },
      { number: 18, name: "TBD" },
      { number: 19, name: "TBD" },
      { number: 20, name: "TBD" },
      { number: 21, name: "TBD" },
      { number: 22, name: "TBD" },
      { number: 23, name: "TBD" },
    ],
  },
  performances: [
    { category: "Coach", player: "Régis Sonnes", value: "Spain W" },
    { category: "Coach", player: "Guilherme Coghetto", value: "Brazil W" },
    { category: "Captain", player: "Lourdes Alameda", value: "Spain W" },
    { category: "Captain", player: "TBD", value: "Brazil W" },
    { category: "Venue", player: "Kai Tak Youth Sports Ground", value: "Hong Kong" },
  ],
},

 // ==================================================
  // WOMEN'S INTERNATIONAL TESTS - Stand Alone
  // ==================================================

  {
  matchKey: "ireland-w-vs-japan-w-standalone",
  timeline: [
    { minute: "0'", label: "Kick-off — Virgin Media Park, Cork" },
    { minute: "40'", label: "Half Time — Ireland 22–7 Japan" },
    { minute: "80'", label: "Full Time — Ireland 43–19 Japan" },
  ],
  highlightsUrl: "https://www.youtube.com/watch?v=kPBxy_-5Mq4",
  matchStats: {
    home: { metresMade: 0, carries: 0, defendersBeaten: 0, cleanBreaks: 0, offloads: 0, tacklesMade: 0, tacklesMissed: 0, turnoversWon: 0, penaltiesConceded: 0 },
    away: { metresMade: 0, carries: 0, defendersBeaten: 0, cleanBreaks: 0, offloads: 0, tacklesMade: 0, tacklesMissed: 0, turnoversWon: 0, penaltiesConceded: 0 },
  },
  performances: [
    { category: "Coach", player: "Scott Bemand", value: "Ireland" },
    { category: "Coach", player: "TBD", value: "Japan" },
    { category: "Venue", player: "Virgin Media Park", value: "Cork" },
    { category: "Note", player: "Ireland", value: "Seven tries; second win over Japan in consecutive weeks" },
  ],
},

{
  matchKey: "spain-w-vs-south-africa-w",
  timeline: [
    { minute: "0'", label: "Kick-off — La Cartuja, Seville" },
    { minute: "40'", label: "Half Time — Spain 0–10 South Africa" },
    { minute: "80'", label: "Full Time — Spain 0–20 South Africa" },
  ],
  highlightsUrl: "https://www.youtube.com/watch?v=Pw1jDh8CIxc",
  matchStats: {
    home: { metresMade: 0, carries: 0, defendersBeaten: 0, cleanBreaks: 0, offloads: 0, tacklesMade: 0, tacklesMissed: 0, turnoversWon: 0, penaltiesConceded: 0 },
    away: { metresMade: 0, carries: 0, defendersBeaten: 0, cleanBreaks: 0, offloads: 0, tacklesMade: 0, tacklesMissed: 0, turnoversWon: 0, penaltiesConceded: 0 },
  },
  performances: [
    { category: "Coach", player: "TBD", value: "Spain" },
    { category: "Coach", player: "TBD", value: "South Africa" },
    { category: "Venue", player: "La Cartuja", value: "Seville" },
    { category: "Note", player: "South Africa", value: "Clean sheet win; 7th consecutive victory over Spain" },
  ],
},

]